import Order from 'communication/types/order/Order';
import { OutliersBenchmarkStrategy } from 'widgets/outliers/data/benchmarksStrategies/index';
import isNil from 'lodash/isNil';

export const adjustedArrivalPriceBenchmarkStrategy: OutliersBenchmarkStrategy =
    {
        mapOrder: (order, exchangeRate) => {
            if (isNil(order.arrivalPD)) {
                return undefined;
            }

            const adjustedArrivalPriceUser = adjustArrivalPrice(
                order,

                order.arrivalPD * exchangeRate
            );

            return isNil(adjustedArrivalPriceUser)
                ? undefined
                : {
                      benchmarkPrice: adjustedArrivalPriceUser,
                  };
        },
        getRequiredColumns: () => ['arrivalPD', 'side', 'exCostTx'],
    };

export function adjustArrivalPrice(
    order: Order,

    arrival: number | undefined
) {
    const estCost = order.exCostTx;

    if (isNil(arrival) || isNil(estCost)) {
        return undefined;
    }

    const factor = order.side === 'B' ? 1 : -1;

    return arrival! + ((arrival! * estCost) / 10000) * factor;
}
